// Empty module used by next.config.js to replace Next.js's
// polyfill-module bundle. See `webpack` config there for context.
export {};
